<template>
 <div class="verifyForgot-pass">
  <section>
      <div class="row">
        <div class="container">
          <div class="box-content vh-100 d-flex flex-column justify-content-center align-middle align-items-center">
            <div class="box">
              <div class="box-content">
                <center>
                  <h1>{{message}}</h1>
                </center>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
 </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'Verify',
  data: function () {
    return {
      data: {
        password: this.$route.params.password,
        email_address: this.$route.query.email_address
      },
      message: null
    }
  },
  created () {
    this.passData()
    setTimeout(function () { this.message = 'This link is already expire or invalid.' }, 3000)
  },
  methods: {
    ...mapActions('login', ['verifyMember']),
    passData: function () {
      this.verifyMember(this.data)
    }
  }
}
</script>
